import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { enregistrerSW } from './pwa/enregistrerSW';
import { redirigerVersHoteCanonique } from './pwa/origine';
import './styles/global.css';

// Avant tout le reste : si on tourne sur une URL *.pages.dev, l'API et le
// cookie de session ne fonctionneront pas. On renvoie vers le domaine
// personnalise sans rien monter — et surtout sans enregistrer de service
// worker sur la mauvaise origine, qui y laisserait une app en cache.
if (!redirigerVersHoteCanonique()) {
  const racine = document.getElementById('racine');
  if (!racine) throw new Error('Element #racine introuvable.');

  createRoot(racine).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );

  enregistrerSW();
}
